import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

type NewSubscriptionActionProps = {
    className?: string
}

export default function NewSubscriptionAction({ className }: NewSubscriptionActionProps) {
    return (
        <Button asChild className={className}>
            <Link to='/subscriptions/new'>New Subscription</Link>
        </Button>
    )
}


